import {useCompanyRoutes} from './routes';
import {GetDefaultIndex} from '../../components';
import { useGetCompanyCommonInfoQuery } from "../../features/api/apiSlice";

export {useCompanyRoutes};

export default GetDefaultIndex({title: 'شرکت ها', query: useGetCompanyCommonInfoQuery});
